import React, { useState } from 'react';
import { Box, Button, CssBaseline, InputBase, ListItemText, ListItemIcon, Divider, List, Drawer, ListItem, Menu, MenuItem, IconButton, Badge, AppBar, Toolbar, Typography, Grid, Container } from "@material-ui/core";
import { AssessmentTwoTone as AssessmentTwoToneIcon, MoveToInbox as InboxIcon, Notifications as NotificationsIcon, Search as SearchIcon, More as MoreIcon, AccountCircle, ChevronRight as ChevronRightIcon, ChevronLeft as ChevronLeftIcon } from "@material-ui/icons";
import { Parallax } from "react-parallax";
import { makeStyles, useTheme, fade } from '@material-ui/core/styles';
import clsx from 'clsx';
import MailIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import { ContactUs } from 'src/ContactUs';
import { colors, IBackground } from 'src/theme';
import { Theme } from '@material-ui/core';

const imgHeader = require("../img/header.jpg");
const imgLogo = require("../img/logo.png");

interface IStyleProps {
    colors: IBackground
}
interface IHeaderProps {
    changeColor: string;
    changeColorOffset: number;
}

export const Header: React.FC<IHeaderProps> = ({ changeColor, changeColorOffset }) => {
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const primaryColor = "transparent";
    const classes = useStyles({ colors: colors.header });
    const [enableOffsetColor, setEnableOffsetColor] = useState(false);
    const headerColorChange = () => {
        if (!enableOffsetColor && window.pageYOffset > changeColorOffset)
            setEnableOffsetColor(true);
        else if (enableOffsetColor && window.pageYOffset < changeColorOffset)
            setEnableOffsetColor(false);

    };

    React.useEffect(() => {
        if (changeColorOffset) {
            window.addEventListener("scroll", headerColorChange);
        }
        return () => {
            if (changeColorOffset) {
                window.removeEventListener("scroll", headerColorChange);
            }
        };
    });

    return (
        <div className={classes.root}>

            <AppBar className={classes.appbar}>
                <Box display="flex" flexDirection="column">
                    <Box className={classes.header} >
                        <Container>
                            <Box display="flex" flexDirection="row" >

                                <Box flexGrow={1} display="flex">
                                    <img src={imgLogo} alt="hlavní logo" className={clsx(classes.logo, { [classes.logoOffset]: enableOffsetColor })} />
                                </Box>
                                <Box display="flex" flexDirection="row" textAlign="center" className={clsx(classes.contacts, { [classes.contactsOffset]: enableOffsetColor })}>
                                    <Box display={{ xs: 'none', sm: 'none', md:"flex" }} className={classes.contactDetail}><MailIcon className={classes.icon} /> <a href="rb.elektroprace@seznam.cz">rb.elektroprace@seznam.cz</a></Box>
                                    <Box display="flex" className={classes.contactDetail}><PhoneIcon className={classes.icon} /> <span>+420&nbsp;604&nbsp;485&nbsp;274</span></Box>
                                </Box>
                            </Box>
                        </Container>
                    </Box>
                </Box>

            </AppBar>
            <Box>
                <Parallax blur={0} strength={600} bgImage={imgHeader} bgImageStyle={{ marginLeft: "-1px" }} className={classes.parallax}>

                    <Container className={classes.motto}>
                        <h1>Radoslav Bednář</h1>
                        <h2>Návrhy a realizace elektrorozvodů a rozvaděčů<br /> Průmyslové rozvody, montáže centrálních vysavačů</h2>
                    </Container>
                </Parallax>
            </Box>
        </div>
    )
}
const useStyles = makeStyles<Theme, IStyleProps>((theme) => ({
    root: (props) => ({
        fontFamily: "oswald-light",
        color: colors.header.color,
        "& a": {
            color: colors.header.color,
            fontFamily: "oswald-light",

        }

    }),
    parallax: {
        height: 600,
        [theme.breakpoints.down("md")]: {
            height: 500
        },
        [theme.breakpoints.down("sm")]: {
            height: 400
        },
        [theme.breakpoints.down("xs")]: {
            height: 300
        }
    },
    motto: {
        marginTop: 250,
        "& h1": {
            fontSize: "4.9em",
            [theme.breakpoints.down("md")]: {
                fontSize: "3.9em",

            },
            [theme.breakpoints.down("xs")]: {
                fontSize: "2.9em",

            },
            marginBottom: 5,
            border: "1 px solid white"
        },
        "& h2": {
            letterSpacing: 1,
            [theme.breakpoints.down("xs")]: {
                fontSize: "0.9em",

            }
        },
        [theme.breakpoints.down("md")]: {
            marginTop: 200,

        },
        [theme.breakpoints.down("sm")]: {
            marginTop: 150,

        },
        [theme.breakpoints.down("xs")]: {
            marginTop: 130,

        }
    },
    logo: {
        transition: "height 1.5s ease",
        height: "60px",
    },
    logoOffset: {
    },

    contacts: {
        fontSize: "1.0em",
        transition: "all 1.5s ease",
        paddingTop: 5,
        "& h2, & a": {
            textDecoration: "none",
            fontSize: 10,
            fontFamily: "roboto-light",
            pading: 0,
            margin: 0,
        },
        "& h2": {
            textTransform: "uppercase",
            color: "#CCC"
        },
        "& a": {
            fontSize: "1em",
        }
    },
    contactsOffset: {
    },
    contactDetail: {

        textDecoration: "none",
        fontSize: "1.7em",
        lineHeight: "1.8em",
        alignItems: "center",
    },
    icon: {
        fontSize: 30,
        margin: "auto",
        marginLeft: 25,
        marginRight: 5,
    },
    header: props => ({
        color: props.colors.color,
        background: props.colors.bgColor,
        padding: "15px 0px",

    }),
}));


// WEBPACK FOOTER //
// ./src/layout/Header.tsx